import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import { Accordion, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import TextArea from "../../components/form-fields/TextArea";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';     
import { truncateText } from "../../utils";            /* Added Line */              /* Added Line */

export default function MailMessages() {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [t, i18n] = useTranslation();         /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);
  
  const validationSchema = yup.object({
  });

  const arrangeBeforePersist = (values) => {
    let payload = {
      mailCode: values.mailCode,
      descr: values.descr,
      subject: values.subject,
      message: values.message,
      id: values.id,
      stId: values.stId || 90,
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      mailCode: data.mailCode,
      descr: data.descr,
      subject: data.subject,
      message: data.message,
      id: data.id,
      stId: data.stId,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };
  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="mail-message/config"
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="stId"
                      label={t("demandList.durum")}
                      colNumber="3"
                      oper="EQ"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={ configData && configData.durum }
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            hideNewAddButton
            title={t("pageTitleofDemandCreate.mailMesajı")}
            size="lg"
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              endPointUrl="mail-message/create"
              fetchPointUrl="mail-message/find"
              editPointUrl="mail-message/update"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              <Field
                name="mailCode"
                label={t("mailMessages.mailKodu")}
                colNumber="12"
                component={TextInput}
                readOnly
              />
              <Field
                name="descr"
                label={t("mailMessages.aciklama")}
                colNumber="12"
                component={TextInput}
              />
              <Field
                name="subject"
                label={t("mailMessages.konu")}
                colNumber="12"
                component={TextInput}
              />
              <Field
                name="message"
                label={t("mailMessages.mesaj")}
                colNumber="12"
                component={TextArea}
              />
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="gruplar"
            endpoint="mail-message/list"
            keyField="id"
            refreshList={refreshList}
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header"
              },
              {
                dataField: "mailCode",
                text: `${t("demandList.mailKodu")}`,
                sort: true,
              },
              {
                dataField: "subject",
                text: `${t("demandList.konu")}`,
                sort: true,
              },
              {
                dataField: "descr",
                text: `${t("demandList.aciklama")}`,
                formatter: (data) => truncateText(data, 50, 40),
                sort: true,
              },
              {
                dataField: "gnlStDto.name",
                text: `${t("demandList.durum")}`,
                sort: true,
              },
            ]}
            customBody={{
              filters: filters,
            }}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                requestTo(ABT.ACTIVE, "mail-message/aktif-pasif"),
                requestTo(ABT.PASSIVE, "mail-message/aktif-pasif"),
                /* requestTo(ABT.DELETE, "mail-message/delete"), */
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
